/*globals $:false */

import { ConfirmDialog } from '@cob/ui-genesis/helpers/cob.dialog.js';

import UriBuilder from '../helpers/module.uribuilder.js';

import { sprintf } from 'sprintf-js';

import tmpl_definition_dragging from '../templates/definition-dragging.dot';
import tmpl_definitions from '../templates/definitions.dot';

import utils from '@cob/ui-genesis/cob.utils.js';

// `$container`: the jquery HTML wrapper for the enclosing element
//
// callbacks:
//
// * `generateDiagram()`: Generate the definition relation diagram
// * `createDefinition()`: Go to the module to create definitions
// * `getDefinition(definitionId)`: get definition object with this definitionId
// * `cloneDefinition(definitionId)`: clone this specific definition
// * `enableDefinition(definitionId)`: Enable the definition with this id
// * `disableDefinition(definitionId)`: Disable the definition with this id
// * `deleteDefinition(definitionId)`: Delete the definition with this id
var DefinitionsV = function(core, $container, callbacks) {

    var $definitionsContainer = $('.js-definitions-container', $container),
        $definitionPlaceholder = $('.placeholder', $definitionsContainer) ,
        $definitionList = $('ul.list', $definitionsContainer);

    var _buildHtmlDefinitions = function(definitionsM) {
        definitionsM.forEach((def) => {
           def.simpleSearchUri = UriBuilder.buildUriForSimpleSearchDefinition(def.getId(), '')
           def.editDefinitionUri = UriBuilder.buildEditDefinitionUri(def.getId())
           def.htmlEncodedDescription = utils.encodeHTML(def.getDescription())
        });
        var $list = $(tmpl_definitions({definitionsM: definitionsM}))
            // We just to detach the top li and not the dropdown li.
            .find('li.js-definition-item')
            .detach();

        core.translate('recordm.domains', $list);

        $list.each(function(idx, el) {

            var $definition = $(el);

            $definition.draggable({
                appendTo: $container,
                helper: function() {
                    return $(tmpl_definition_dragging({
                       definition: callbacks.getDefinition($definition.data('definition-id'))
                    }));
                }
            });
        });

        return $list;
    };

    var _showDefinitions = function(definitionsM) {
        $definitionList.html(_buildHtmlDefinitions(definitionsM));
    };

    var _showDefinitionPlaceholder = function() {
        $definitionPlaceholder.removeClass('hidden');
    };

    var _hideDefinitionPlaceholder = function() {
        $definitionPlaceholder.addClass('hidden');
    };

    var _isContainerVisible = function(){
       return $definitionsContainer.is(":visible");
    };

    var _addDefinition = function(definitionM, afterDefinitionId) {
        var $definitions = _buildHtmlDefinitions([definitionM]);

        if (afterDefinitionId) {
            $definitions.insertAfter(
                $definitionList.find('li.js-definition-item[data-definition-id="' + afterDefinitionId + '"]')
            );

        } else {
            _hideDefinitionPlaceholder();
            $definitionList.prepend($definitions);
        }

        //we need this visibility check otherwise jquery may give a NPE when coming back from adding a new def
        if (_isContainerVisible()) {
            $definitions.effect('highlight', {color: '#fcdebc'}, 1000);
        } else {
            utils.delayed(function() {
                if (_isContainerVisible()) {
                    $definitions.effect('highlight', {color: '#fcdebc'}, 1000);
                }
            }, 600);
        }
    };

    var _deleteDefinition = function(definitionId) {
        $definitionList.find('li.js-definition-item[data-definition-id="' + definitionId + '"]')
            .remove();
    };

    var _addListenersToDefinitionContainer = function() {
        $definitionList.on('click', '.js-index', function(e) {
            e.preventDefault();

            /* eslint-disable-next-line no-invalid-this  */
            var $definitionItem = $(this).parents('.js-definition-item');
            callbacks.indexDefinition($definitionItem.data('definition-id'));
        });

        $definitionList.on('click', '.js-full-index', function(e) {
            e.preventDefault();

            /* eslint-disable-next-line no-invalid-this  */
            var $definitionItem = $(this).parents('.js-definition-item');
            callbacks.indexDefinition($definitionItem.data('definition-id'), true);
        });

        $definitionList.on('click', '.js-upgrade', function(e) {
            e.preventDefault();

            /* eslint-disable-next-line no-invalid-this  */
            var $definitionItem = $(this).parents('.js-definition-item');
            callbacks.upgradeInstances($definitionItem.data('definition-id'));
        });

        $definitionList.on('click', '.js-clone', function(e) {
            e.preventDefault();

            /* eslint-disable-next-line no-invalid-this  */
            var $definitionItem = $(this).parents('.js-definition-item');
            callbacks.cloneDefinition($definitionItem.data('definition-id'));
        });

        $definitionList.on('click', '.js-disable', function(e) {
            e.preventDefault();

            /* eslint-disable-next-line no-invalid-this  */
            var $definitionItem = $(this).parents('.js-definition-item');
            callbacks.disableDefinition($definitionItem.data('definition-id'));
        });

        $definitionList.on('click', '.js-enable', function(e) {
            e.preventDefault();

            /* eslint-disable-next-line no-invalid-this  */
            var $definitionItem = $(this).parents('.js-definition-item');
            callbacks.enableDefinition($definitionItem.data('definition-id'));
        });

        $definitionList.on('click', '.js-delete', function(e) {
            e.preventDefault();

            /* eslint-disable-next-line no-invalid-this  */
            var $definitionItem = $(this).parents('.js-definition-item'),
                definitionName = $definitionItem.find('.js-definition-name').text().trim();

            ConfirmDialog(core, {
                    message: sprintf(core.translateString('recordm.domains', 'definitions.msg.delete'), definitionName),
                    confirmBtnLabel: core.translateString('recordm.domains', 'definitions.actions.delete'),
                    confirmBtnClass: 'btn-danger'
                },
                {
                    requestConfirmed: function() {
                        callbacks.deleteDefinition($definitionItem.data('definition-id'));
                    }
                }
            );
        });

        $definitionsContainer.on('click', '.js-generate-er-diagram', function(e){
            e.preventDefault();
            callbacks.generateDiagram();
        });

        $definitionsContainer.on('click', '.js-new-definition', function(e){
            e.preventDefault();

            callbacks.createDefinition();
        });

        $definitionsContainer.on('click', '.js-import-definition', function(e){
            e.preventDefault();

            callbacks.importDefinition();
        });
    };

    var _destroy = function() {
        $definitionsContainer.off('click');

        $definitionList.off('click', '.js-copy');
        $definitionList.off('click', '.js-disable');
        $definitionList.off('click', '.js-enable');
        $definitionList.off('click', '.js-delete');
    };

    var _init = function() {

        _addListenersToDefinitionContainer();
    };

    return {
        init: _init,
        destroy: _destroy,

        showDefinitions: _showDefinitions,
        showDefinitionPlaceholder: _showDefinitionPlaceholder,

        addDefinition: _addDefinition,
        deleteDefinition: _deleteDefinition
    }
};

export default DefinitionsV;
